const dailyPrice = document.querySelector('.js-daily-price')

if (dailyPrice !== null) {
    const variantsJSON = JSON.parse(document.querySelector('[data-cpd-variants-json]').innerHTML)
    const valueJSON = JSON.parse(document.querySelector('[data-cpd-value-json]').innerHTML)

    const cwSelect = document.querySelector('.js_product_var_change');

    const variant_and_cpd = {}
    variantsJSON.forEach((variant, i) => {
        variant_and_cpd[variant] = valueJSON[i]
    });

    document.addEventListener('change:cpd', e => {
        if (cwSelect !== null) {
            const variantId = parseInt(cwSelect.value)
            dailyPrice.textContent = variant_and_cpd[variantId]
        }
    })

    document.addEventListener('change', e => {
        if (cwSelect === null) {
            const variantInput = e.target.closest('form').querySelector('input[name="id"]')
            const variantId = parseInt(variantInput.value)
            dailyPrice.textContent = variant_and_cpd[variantId]
        }
    })   
}